.root {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.header {
  align-items: center;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  flex: none;
  gap: 8px;
  padding: 10px 12px;
}

.back {
  align-items: center;
  background: transparent;
  border: none;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  gap: 4px;
  padding: 0;

  &:focus-visible {
    box-shadow: 0 0 0 2px #7c3aed;
    outline: none;
  }
}

.title {
  color: #5b21b6;
  flex: 1;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  padding: 10px 14px;
}

.footer {
  border-top: 1px solid #e2e8f0;
  flex: none;
  padding: 10px 14px;
}

.done {
  background: #7c3aed;
  border: none;
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  height: 44px;
  width: 100%;

  &:focus-visible {
    box-shadow: 0 0 0 2px #5b21b6;
    outline: none;
  }
}
